import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const fetchSavedDrugQuotes = async (facilityName, pageNumber = 1, pageSize = 20) => {
    const params = { pageNumber, pageSize };

    const facilityIds = Array.isArray(facilityName) ? facilityName : facilityName ? [facilityName] : [];
    if (facilityIds.length > 0) {
        params.facilityIds = facilityIds;
    }

    const response = await SrxApi.get('/drugsearch/savedquotes', {
        params,
        paramsSerializer: (p) =>
            Object.entries(p)
                .flatMap(([key, value]) =>
                    Array.isArray(value)
                        ? value.map((v) => `${key}=${encodeURIComponent(v)}`)
                        : `${key}=${encodeURIComponent(value)}`
                )
                .join('&'),
    });
    return response?.data;
};

const useSavedDrugQuotes = (facilityName, pageNumber = 1, pageSize = 20) => {
    const {
        data: savedDrugQuotesRaw = null,
        isFetching: isSavedDrugQuotesLoading,
        refetch: refetchSavedDrugQuotes,
    } = useQuery(
        ['savedDrugQuotes', facilityName, pageNumber, pageSize],
        () => fetchSavedDrugQuotes(facilityName, pageNumber, pageSize),
        {
            staleTime: 0,
            onError: (error) => {
                const msg = error?.response?.data?.message || error?.message || 'Failed to load saved drug quotes';
                toast.error(msg);
            },
        }
    );

    return {
        savedDrugQuotesRaw,
        isSavedDrugQuotesLoading,
        refetchSavedDrugQuotes,
    };
};

export default useSavedDrugQuotes;
